import React from "react";
import styled from "styled-components";
// Components
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";
import WorkshopsPreview from "../components/Sections/WorkshopsPreview";
// Assets
import HeaderImage from "../assets/img/header-img.png";
import TitleMask from "../assets/logo/LogoTitleMask.png";
import HeroVideoSrc from "../assets/video/hero.mp4";
import HeroPoster from "../assets/video/hero-poster.jpg";

export default function Landing({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="home" />

      {/* ===== HERO ===== */}
      <HeroSection id="home">
        <HeroAccent aria-hidden="true" />
        <div className="container flexSpaceCenter" style={{ position: "relative", zIndex: 1 }}>
          <HeroLeft className="flexCenter">
            <div className="hero-in">
              <h1 className="extraBold font60" style={{ lineHeight: "1.1" }}>
                ברוכה הבאה אל
                {/* the lettering is cut out of the logo, so it matches it exactly */}
                <span
                  className="logoTitle"
                  role="img"
                  aria-label="הלב הצבעוני"
                  style={{ "--title-mask": `url(${TitleMask})` }}
                />
              </h1>
              <HeroSub className="font20 semiBold" style={{ marginTop: "20px", color: "var(--rose-600)" }}>
                יצירה. התבוננות. צמיחה.
              </HeroSub>
              <HeroP className="font15">
                כאן תמצאי כלים יצירתיים שיעזרו לך להתחבר לעצמך:
                יומן ויזואלי, קלפי נפש ולוח חזון.
                כי כל אישה ראויה לשפה שלה.
              </HeroP>
              <HeroBtns>
                <ProductBtn onClick={() => navigate("journal")} className="pinkBg whiteColor radius8">יומן ויזואלי</ProductBtn>
                <ProductBtn onClick={() => navigate("cards")} className="greenBg darkColor radius8">קלפי נפש</ProductBtn>
                <ProductBtn onClick={() => navigate("visionboard")} className="coralBg darkColor radius8">לוח חזון</ProductBtn>
              </HeroBtns>
            </div>
          </HeroLeft>
          <HeroRight>
            {/* recolored to the site palette; muted so it can autoplay */}
            <HeroVideo
              className="radius8 float"
              src={HeroVideoSrc}
              poster={HeroPoster}
              autoPlay
              muted
              loop
              playsInline
              aria-hidden="true"
            />
          </HeroRight>
        </div>
      </HeroSection>

      {/* ===== PRODUCTS OVERVIEW ===== */}
      <ProductsSection id="products" className="lightBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">הכלים שלנו</h2>
            <p className="font15 greyColor">בחרי את הכלי שמדבר אלייך</p>
          </SectionHeader>
          <ProductGrid className="stagger-reveal">

            {/* JOURNAL */}
            <ProductCard>
              <ProductCardImg>
                <img src={HeaderImage} alt="יומן ויזואלי" className="radius8" />
                {/* IMAGE PLACEHOLDER — swap for journal product photo */}
                <CardImgPlaceholder className="radius8 greenBg">
                  <span>📸 תמונת יומן</span>
                </CardImgPlaceholder>
              </ProductCardImg>
              <ProductCardBody>
                <h3 className="font25 extraBold darkColor">היומן הויזואלי 📒</h3>
                <p className="font14" style={{ margin: "15px 0 20px", lineHeight: "1.7" }}>
                  יומן שבו כותבים, אבל גם מציירים, מדביקים, גוזרים, שופכים צבעים.
                  אין בו חוקים. אין יפה או מכוער. זה מרחב אישי שבו הכל הולך.
                </p>
                <LearnMoreBtn onClick={() => navigate("journal")} className="darkBg whiteColor radius8">
                  לעמוד היומן ←
                </LearnMoreBtn>
              </ProductCardBody>
            </ProductCard>

            {/* CARDS */}
            <ProductCard>
              <ProductCardImg>
                <img src={HeaderImage} alt="קלפי נפש" className="radius8" />
                {/* IMAGE PLACEHOLDER — swap for cards product photo */}
                <CardImgPlaceholder className="radius8 pinkBg">
                  <span>📸 תמונת קלפים</span>
                </CardImgPlaceholder>
              </ProductCardImg>
              <ProductCardBody>
                <h3 className="font25 extraBold" style={{ color: "var(--rose-600)" }}>קלפי נפש 🃏</h3>
                <p className="font14" style={{ margin: "15px 0 20px", lineHeight: "1.7" }}>
                  הקלפים שלך הם השפה של הלב שלך.
                  כשאת יוצרת קלפים בעצמך, את בוחרת את המילים, הצבעים, הדימויים והכוונות.
                  הם בדיוק בשפה שלך.
                </p>
                <LearnMoreBtn onClick={() => navigate("cards")} className="pinkBg whiteColor radius8">
                  לעמוד הקלפים ←
                </LearnMoreBtn>
              </ProductCardBody>
            </ProductCard>

            {/* VISION BOARD */}
            <ProductCard>
              <ProductCardImg>
                <img src={HeaderImage} alt="לוח חזון" className="radius8" />
                {/* IMAGE PLACEHOLDER — swap for vision board product photo */}
                <CardImgPlaceholder className="radius8 coralBg">
                  <span>📸 תמונת לוח חזון</span>
                </CardImgPlaceholder>
              </ProductCardImg>
              <ProductCardBody>
                <h3 className="font25 extraBold" style={{ color: "var(--rose-600)" }}>לוח חזון 🌟</h3>
                <p className="font14" style={{ margin: "15px 0 20px", lineHeight: "1.7" }}>
                  לוח חזון הוא כלי עוצמתי חזותי שמסייע להמחיש ולמקד מטרות, חלומות ושאיפות אישיות.
                  תלי אותו במקום שתראי כל יום.
                </p>
                <LearnMoreBtn onClick={() => navigate("visionboard")} className="pinkBg whiteColor radius8">
                  לעמוד לוח החזון ←
                </LearnMoreBtn>
              </ProductCardBody>
            </ProductCard>

          </ProductGrid>
        </div>
      </ProductsSection>

      {/* ===== WORKSHOPS PREVIEW ===== */}
      <WorkshopsPreview navigate={navigate} />

      {/* ===== GALLERY STRIP ===== */}
      <GalleryStrip>
        <GalleryItem>
          {/* IMAGE PLACEHOLDER */}
          <GalleryPlaceholder style={{ background: "var(--tint-rose)" }}>
            <span>📸 גלריה 1</span>
          </GalleryPlaceholder>
        </GalleryItem>
        <GalleryItem>
          <GalleryPlaceholder style={{ background: "var(--tint-butter)" }}>
            <span>📸 גלריה 2</span>
          </GalleryPlaceholder>
        </GalleryItem>
        <GalleryItem>
          <GalleryPlaceholder style={{ background: "var(--tint-rose)" }}>
            <span>📸 גלריה 3</span>
          </GalleryPlaceholder>
        </GalleryItem>
        <GalleryItem>
          <GalleryPlaceholder style={{ background: "var(--tint-butter)" }}>
            <span>📸 גלריה 4</span>
          </GalleryPlaceholder>
        </GalleryItem>
      </GalleryStrip>

      {/* ===== ABOUT ===== */}
      <AboutSection id="about">
        <div className="container">
          <AboutInner className="flexSpaceCenter">
            <AboutImageSide>
              <AboutImgMain>
                {/* IMAGE PLACEHOLDER — swap for your personal photo */}
                <AboutImgPlaceholder className="radius8">
                  <span>📸 התמונה שלי</span>
                </AboutImgPlaceholder>
                <AboutImgSecondary>
                  {/* IMAGE PLACEHOLDER — swap for a second personal/work photo */}
                  <SmallImgPlaceholder className="radius8">
                    <span>📸 תמונה נוספת</span>
                  </SmallImgPlaceholder>
                </AboutImgSecondary>
              </AboutImgMain>
            </AboutImageSide>
            <AboutTextSide>
              <p className="font15 semiBold" style={{ color: "var(--rose-600)" }}>קצת עליי</p>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                הסיפור שלי
              </h2>
              {/* TEXT PLACEHOLDER — replace with your personal story */}
              <AboutText className="font15">
                כאן תוכלי לכתוב את הסיפור שלך: מי את, מה מניע אותך,
                למה את עושה את מה שאת עושה.
                <br /><br />
                {/* IMAGE PLACEHOLDER — you can add a quote or image inline here */}
                שתפי את הדרך שלך ואת הלב שמאחורי הכלים האלה.
                זה המקום שבו הקוראות מתחברות אלייך כאדם.
              </AboutText>
              <AboutImgRow>
                {/* IMAGE PLACEHOLDER — small decorative or work photos */}
                <MiniImgBox className="radius6">
                  <span>📸 תמונה קטנה 1</span>
                </MiniImgBox>
                <MiniImgBox className="radius6">
                  <span>📸 תמונה קטנה 2</span>
                </MiniImgBox>
                <MiniImgBox className="radius6">
                  <span>📸 תמונה קטנה 3</span>
                </MiniImgBox>
              </AboutImgRow>
            </AboutTextSide>
          </AboutInner>
        </div>
      </AboutSection>

      {/* ===== TESTIMONIAL / QUOTE BANNER ===== */}
      <QuoteBanner className="pinkBg painted">
        <div className="container textCenter">
          <QuoteText className="whiteColor font25 extraBold">
            "הקלפים שלך הם לא רק קלפים.
            הם השפה של הלב שלך." ❤
          </QuoteText>
          {/* IMAGE PLACEHOLDER — optional background or inline image */}
        </div>
      </QuoteBanner>

      {/* ===== CONTACT ===== */}
      <ContactSection id="contact" className="lightBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">צרי קשר</h2>
            <p className="font15 greyColor">שמחה לשמוע ממך 💌</p>
          </SectionHeader>
          <ContactGrid>
            <ContactForm>
              <FormLabel className="font13 semiBold">שם:</FormLabel>
              <FormInput type="text" name="name" />
              <FormLabel className="font13 semiBold">אימייל:</FormLabel>
              <FormInput type="email" name="email" />
              <FormLabel className="font13 semiBold">נושא:</FormLabel>
              <FormInput type="text" name="subject" />
              <FormLabel className="font13 semiBold">הודעה:</FormLabel>
              <FormTextarea rows="5" name="message" />
              <SubmitBtn className="pinkBg whiteColor radius8 pointer">שלחי הודעה</SubmitBtn>
            </ContactForm>
            <ContactImages>
              <ContactImgTop>
                {/* IMAGE PLACEHOLDER — contact/workshop photo */}
                <ContactImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)" }}>
                  <span>📸 תמונת ליצירת קשר</span>
                </ContactImgPlaceholder>
              </ContactImgTop>
              <ContactImgBottom>
                {/* IMAGE PLACEHOLDER — second contact photo */}
                <ContactImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "160px" }}>
                  <span>📸 תמונה נוספת</span>
                </ContactImgPlaceholder>
                {/* IMAGE PLACEHOLDER — third contact photo */}
                <ContactImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "160px" }}>
                  <span>📸 תמונה נוספת</span>
                </ContactImgPlaceholder>
              </ContactImgBottom>
            </ContactImages>
          </ContactGrid>
        </div>
      </ContactSection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */

const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 80px;
  padding-bottom: 60px;
  display: flex;
  align-items: center;
  direction: rtl;
  /* container inside handles flex layout */
  .flexSpaceCenter {
    min-height: 600px;
    align-items: center;
  }
  @media (max-width: 960px) {
    padding-top: 90px;
    .flexSpaceCenter {
      flex-direction: column;
      min-height: auto;
    }
  }
`;
/* soft watercolor bloom behind the photo */
const HeroAccent = styled.div`
  position: absolute;
  top: 18%;
  left: 8%;
  width: 36%;
  height: 64%;
  z-index: 0;
  border-radius: 58% 42% 55% 45% / 45% 55% 45% 55%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0.15) 55%, transparent 72%);
  filter: blur(24px);
  animation: bloomMorph 14s ease-in-out infinite alternate;
  @keyframes bloomMorph {
    0%   { border-radius: 58% 42% 55% 45% / 45% 55% 45% 55%; transform: rotate(0deg) scale(1); }
    100% { border-radius: 42% 58% 45% 55% / 55% 45% 55% 45%; transform: rotate(8deg) scale(1.06); }
  }
  @media (max-width: 960px) { display: none; }
`;
const HeroLeft = styled.div`
  width: 50%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 40px 0 0;
    text-align: center;
  }
`;
const HeroRight = styled.div`
  width: 46%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
  }
`;
const HeroSub = styled.p``;
const HeroP = styled.p`
  max-width: 470px;
  padding: 15px 0 30px 0;
  line-height: 1.7rem;
  @media (max-width: 960px) {
    max-width: 100%;
    text-align: center;
  }
`;
const HeroBtns = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  @media (max-width: 960px) {
    justify-content: center;
  }
`;
const ProductBtn = styled.button`
  padding: 13px 26px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 999px !important;
  cursor: pointer;
`;
const HeroVideo = styled.video`
  display: block;
  width: 100%;
  height: 460px;
  object-fit: cover;
  background: var(--grad-blush);
  box-shadow: var(--shadow-lift);
  border: 8px solid rgba(255, 255, 255, 0.7);
  @media (max-width: 960px) {
    height: 300px;
  }
  /* keep it a short banner on phones so the title stays in view */
  @media (max-width: 560px) {
    height: 190px;
    border-width: 5px;
  }
`;

/* Products section */
const ProductsSection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
  p { margin-top: 10px; }
`;
const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;
const ProductCard = styled.div`
  background: var(--glass-strong);
  backdrop-filter: blur(6px);
  border-radius: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: var(--shadow-card);
  /* image zooms gently inside its frame */
  &:hover > div:first-child > * { transform: scale(1.06); }
  overflow: hidden;
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
`;
const ProductCardImg = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: none; /* hide placeholder images — remove when you have real ones */
  }
`;
const CardImgPlaceholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
  transition: transform 0.9s var(--ease-out);
`;
const ProductCardBody = styled.div`
  padding: 25px;
`;
const LearnMoreBtn = styled.button`
  padding: 10px 22px;
  border-radius: 999px !important;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
`;

/* Gallery strip */
const GalleryStrip = styled.div`
  display: flex;
  height: 220px;
  @media (max-width: 600px) {
    flex-wrap: wrap;
    height: auto;
  }
`;
const GalleryItem = styled.div`
  flex: 1;
  min-width: 120px;
  @media (max-width: 600px) {
    flex: 0 0 50%;
    height: 140px;
  }
`;
const GalleryPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;

/* About section */
const AboutSection = styled.section`
  padding: 100px 0;
  direction: rtl;
`;
const AboutInner = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
    gap: 50px;
  }
`;
const AboutImageSide = styled.div`
  width: 45%;
  @media (max-width: 860px) {
    width: 100%;
  }
`;
const AboutImgMain = styled.div`
  position: relative;
`;
const AboutImgPlaceholder = styled.div`
  width: 100%;
  height: 420px;
  background: var(--tint-rose);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--rose-600);
`;
const AboutImgSecondary = styled.div`
  position: absolute;
  bottom: -30px;
  left: -30px;
  @media (max-width: 860px) {
    bottom: -20px;
    left: -10px;
  }
`;
const SmallImgPlaceholder = styled.div`
  width: 160px;
  height: 160px;
  background: var(--tint-butter);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.813rem;
  font-weight: 600;
  color: var(--ink);
  box-shadow: 0 4px 15px rgba(73, 8, 57,0.15);
`;
const AboutTextSide = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 100%;
    margin-top: 40px;
  }
`;
const AboutText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
  max-width: 480px;
`;
const AboutImgRow = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;
`;
const MiniImgBox = styled.div`
  width: 100px;
  height: 100px;
  background: var(--tint-rose);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.688rem;
  font-weight: 600;
  color: var(--rose-600);
  text-align: center;
  padding: 5px;
  &:nth-child(2) { background: var(--tint-butter); color: var(--ink); }
  &:nth-child(3) { background: var(--tint-rose); }
`;

/* Quote banner */
const QuoteBanner = styled.section`
  padding: 60px 0;
  direction: rtl;
`;
const QuoteText = styled.p`
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
`;

/* Contact section */
const ContactSection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;
const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const FormLabel = styled.label`
  color: var(--ink);
`;
const FormInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--rose-600);
  height: 36px;
  outline: none;
  margin-bottom: 16px;
  font-size: 1rem;
  font-family: inherit;
  direction: rtl;
`;
const FormTextarea = styled.textarea`
  width: 100%;
  background: transparent;
  border: 1px solid var(--rose-600);
  border-radius: 0.5rem;
  outline: none;
  padding: 10px;
  font-size: 1rem;
  font-family: inherit;
  direction: rtl;
  resize: vertical;
  margin-bottom: 16px;
`;
const SubmitBtn = styled.button`
  padding: 14px 34px;
  border-radius: 999px !important;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  max-width: 200px;
`;
const ContactImages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const ContactImgTop = styled.div``;
const ContactImgBottom = styled.div`
  display: flex;
  gap: 15px;
`;
const ContactImgPlaceholder = styled.div`
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
